const messages = {
  title: 'Greška isteka vremena pristupa',
  description: 'Jako nam je žao zbog neugodnosti. Čini se da naš poslužitelj nekako nije primio pravovremeni odgovor.',
  backHomeButton: 'Natrag na nadzornu ploču'
}

export default {
  messages
}
